import React, { useEffect, useState } from "react";
import { useAlertStore } from 'src/hooks/Alert';
import { Pagination } from 'src/reusable/global';
import PCNSearchBox from './PCNSearchBox';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import Helper from 'src/support/Helper';
import Product from "@system/config/product";
import Constants from 'src/support/Constants';
import System from 'src/helper/system';

const PCNListingTable = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [firstPCNCall, setFirstPCNCall] = useState(true)
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });
    const [{ PCNAlertListingByType }, { get_alert_listing_by_type }] = useAlertStore();
    const [{ filter_list }, { }, { }] = useFilterSelectionStore();
    const [AlertFirstServerCall] = useReduxState(false, 'setAlertFirstServerCall');

    const [impactFilter] = useReduxState('', 'setImpactFilter');
    const { setExportParams } = props;
    useEffect(() => {
        const getList = async () => {
            await fetchData();
            await setFirstServerCall(false);
        };
        getList();
    }, [PCNAlertListingByType]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall();
        };
        getList()
    }, [listObj.page, listObj.sortBy, listObj.sortOrder, impactFilter]);


    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit, filter_list]);


    useEffect(() => {
        if (!monitorFunctionCall && ((!firstPCNCall && !(__check('ALERT_API_CALL').status)) || AlertFirstServerCall)) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [__check('ALERT_API_CALL').status, firstPCNCall, AlertFirstServerCall])

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    const fetchData = async () => {
        const total = PCNAlertListingByType.totalAlertList;
        await setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
    };

    const fetchAPiCall = async (
        defaultStart = false
    ) => {
        let search_type = ''
        let search_keyword = ''
        if (filter_list.length > 0) {
            search_type = filter_list[0].key
            search_keyword = filter_list[0].searchKeyword
        }
        setExportParams(search_keyword, search_type, impactFilter, listObj.sortBy, listObj.sortOrder); // set params
        await get_alert_listing_by_type({
            "startRow": defaultStart ? 0 : (listObj.limit * (listObj.page - 1)),
            "pageSize": listObj.limit,
            "notificationType": Constants.alertTypes.PCN,
            "keyword": search_keyword,
            "searchType": search_type,
            "sortBy": listObj.sortBy,
            "sortOrder": listObj.sortOrder,
            "filterBy": impactFilter
        })
        setFirstPCNCall(false)
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField })
        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField })
        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName] })

    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    /**
    * Bug    #  : 9670
    * Change #  : Display download message on download
    * Change by : PN
    * Date      : 4 Aug 2023 
    */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }
    return (
        <>
            <PCNSearchBox />
            {(__check('ALERT_API_CALL').status || (PCNAlertListingByType.alertList !== undefined &&
                Object.entries(PCNAlertListingByType.alertList).length > 0)) &&
                <div className='position-relative'>
                    <div>
                        {__check(['ALERT_API_CALL'], { overlay: true }).render}
                    </div>

                    <div className="table-container table-responsive m-b-30">
                        <table className="bs5 table table-bordered">
                            <thead>
                                <tr className="align-middle">
                                    <th>
                                        Customer Part <br />
                                        Number
                                        <span className={'sort-container ' + getOrderByClass('CPN')}
                                            onClick={async () => { await toggleOrderBy('CPN') }}></span>
                                    </th>
                                    <th>Manufacturing Part Number
                                        <span className={'sort-container ' + getOrderByClass('MPN')}
                                            onClick={async () => { await toggleOrderBy('MPN') }}></span>
                                    </th>
                                    <th>Manufacturer
                                        <span className={'sort-container ' + getOrderByClass('Manufacturer')}
                                            onClick={async () => { await toggleOrderBy('Manufacturer') }}></span>
                                    </th>
                                    <th>PCN Download</th>
                                    <th>Replacement Parts</th>
                                    <th><span>Issue Date</span>
                                        <span className={'sort-container ' + getOrderByClass('IssueDate')}
                                            onClick={async () => { await toggleOrderBy('IssueDate') }}></span>
                                    </th>
                                    <th>Impact
                                        <span className={'sort-container ' + getOrderByClass('Impact')}
                                            onClick={async () => { await toggleOrderBy('Impact') }}></span>
                                    </th>
                                    <th><span>Last Time Buy</span>
                                        <span className={'sort-container ' + getOrderByClass('LastBuy')}
                                            onClick={async () => { await toggleOrderBy('LastBuy') }}></span>
                                    </th>

                                </tr>
                            </thead>
                            {PCNAlertListingByType.alertList && Object.entries(PCNAlertListingByType.alertList).length > 0 &&
                                <tbody>
                                    {PCNAlertListingByType.alertList.map((v, i) => (
                                        <React.Fragment key={i}>
                                            <tr>
                                                <td>{v.customerPartNumber}</td>
                                                <td>
                                                    {v.product && v.product.ItemNumber ?
                                                        <a href={Product.getProductDetailPageRouteURLWithCustomParameter(v.product) + '?ItemNumber=' + v.product.ItemNumber}
                                                            target="_blank"
                                                            className="text-blue2 d-block font-bold" >{v.manufacturerPartNumber}</a>
                                                        :
                                                        <div>{v.manufacturerPartNumber}</div>
                                                    }
                                                </td>
                                                <td>{v.manufacturer}</td>
                                                <td>
                                                    <a href={v.pcnDownload} onClick={() => showDownloadMessage()}><i
                                                        className="fa fa-download me-3 text-black" /><span>PCN</span></a>
                                                </td>
                                                <td>{v.replacementPart}</td>
                                                <td>{v.finalIssueDate}</td>
                                                <td>{v.impactType}</td>
                                                <td>{v.finalLastBuyDate}</td>

                                            </tr>
                                        </React.Fragment>
                                    ))
                                    }
                                </tbody>
                            }
                        </table>
                    </div>
                    <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                    <div className="pagination-right"><span>Displaying <b>5</b> of <b>22</b> Items</span></div>
                </div>
            }
            {!__check('ALERT_API_CALL').status &&
                (!PCNAlertListingByType.alertList || PCNAlertListingByType.alertList.length === 0) &&
                <div className='py-3 alert alert-info text-center'>
                    <span className="text-center w-100">
                        No Alerts Found
                    </span>
                </div>

            }
        </>
    );
}

export default PCNListingTable;